<template>

	<li class="account submenu" :class="{active:showUserMenu}">

		<span v-if="user" @click="onTriggerClick" class="menu-trigger">
			<span class="hide-layout-compact-sm">{{ user.email }}</span>
			<span class="layout-compact-sm"><i class="fas fa-user"></i></span>
		</span>

		<span @click="onTriggerClick" class="menu-trigger">
			<slot name="icon-trigger" class="menu-trigger"></slot>
		</span>

		<div class="popup menu right-side">
			<slot></slot>
		</div>
	</li>

</template>

<script>

import Vue from 'vue';

export default {
	name: 'DropdownMenu',
	data() {
		return {
			showUserMenu: false
		};
	},
	props: ['user'],
	methods: {
		onTriggerClick(e){
			this.showUserMenu = !this.showUserMenu;

			if (this.showUserMenu) {
				window.addEventListener('touchstart', this.onTouchStart, true);
				window.addEventListener('click', this.onClick, true);
				return;
			}

			this.removeListeners();
		},
		onPress(e) {

			let element = e.target.offsetParent || e.target;
			const isTrigger = element.classList.contains('submenu');

			if (isTrigger) {
				//return out and let the trigger hide/show menu
				return;
			}

			if (this.showUserMenu) {
				this.showUserMenu = false;
				this.removeListeners();
			}
		},
		onClick(e) {
			this.onPress(e);
			window.removeEventListener('touchstart', this.onTouchStart, true);
		},
		onTouchEnd(e) {
			this.onPress(e);
			window.removeEventListener('touchend', this.onPress, true);
			window.removeEventListener('touchstart', this.onTouchStart, true);
		},
		onTouchStart(e) {
			window.addEventListener('touchend', this.onTouchEnd, true);
			window.removeEventListener('click', this.onClick, true);
		},
		removeListeners() {
			window.removeEventListener('touchstart', this.onTouchStart, true);
			window.removeEventListener('click', this.onClick, true);
			window.removeEventListener('touchend', this.onTouchEnd, true);
		}
	},
	destroyed() {
		window.removeEventListener('touchstart', this.onTouchStart, true);
		window.removeEventListener('click', this.onClick, true);
		window.removeEventListener('touchend', this.onTouchEnd, true);
	}
};
</script>

<style scoped>
	.menu-trigger span {
		padding: .75em;
	}
</style>



// WEBPACK FOOTER //
// src/components/DropdownMenu.vue